export enum Launch_Relax_High_5 {
  "pt-BR" = "pt-BR",
  "es" = "es",
  "hu" = "hu",
}
